module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"sorry-error":"Désolé, une erreur s\u0027est produite","req-not-found":"Page demandée non trouvée !","take-me-home":"Retour à l\u0027accueil"},"en":{"sorry-error":"Sorry, an error has occured","req-not-found":"Requested page not found!","take-me-home":"Take me home"}}')
  delete Component.options._Ctor
}
